// Libs
import React, { useContext, useEffect, useState } from 'react';
import { Icon, Switch, Tooltip } from 'antd';
import * as Yup from 'yup';

// Own Libs
import * as ui from '@digital/ui';

//Api

//Files
import QuestionarioContextProvider from '../../../../../hooks/useQuestionario';
import CurrencyInput from '@app/components/CurrencyInput';

//Utils
import './custom.css';
import CurrencyInput2 from '@app/components/CurrencyInput2';
import { CurrencyInput3 } from '@app/components/CurrencyInput3';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';
import { Visibility } from '@app/components';


function DefinicaoAdtivo() {
  const [timer, setTimer] = useState<number | null>(null);
  const [tipoDespesa, setTipoDespesa] = useState('');
  const [checkEnable, setCheckEnable] = useState(true);
  const [updateTabela, setUpdateTabela] = useState(false);

  const {
    statusCodigo,
    demandaData,
    valorAditivo,
    setValorAditivo,
    isPrazo,
    setIsPrazo,
    isClausula,
    setIsClausula,
    isValorSemAcrescimoEscopo,
    setIsValorSemAcrescimoEscopo,
    isValorComAcrescimoEscopo,
    setIsValorComAcrescimoEscopo,
    isRemanejamentoVerbasEntreLinhas,
    setIsRemanejamentoVerbasEntreLinhas,
    isAcrescimoEscopoRemanejamentoVerba,
    setIsAcrescimoEscopoRemanejamentoVerba,
    capex,
    setCapex,
    opex,
    setOpex,
    contaResultado,
    setContaResultado,
  } = useContext(QuestionarioContextProvider);

  const validationSchema = Yup.object({
    checkContainer: checkEnable
      ? Yup.boolean().required('Obrigatório o preenchimento de pelo menos uma opção de Aditivo')
      : Yup.boolean(),
  });

  useEffect(() => {
    if (
      isPrazo ||
      isClausula ||
      isValorSemAcrescimoEscopo ||
      isValorComAcrescimoEscopo ||
      isRemanejamentoVerbasEntreLinhas ||
      isAcrescimoEscopoRemanejamentoVerba
    ) {
      setCheckEnable(false);
    } else {
      setCheckEnable(true);
    }
  }, [
    isPrazo,
    isClausula,
    isValorSemAcrescimoEscopo,
    isValorComAcrescimoEscopo,
    isRemanejamentoVerbasEntreLinhas,
    isAcrescimoEscopoRemanejamentoVerba,
  ]);

  useEffect(() => {
    if (capex) {
      setTipoDespesa('capex');
    } else if (opex) {
      setTipoDespesa('opex');
    } else if (contaResultado) {
      setTipoDespesa('resultado');
    }
  }, [demandaData, capex, opex, contaResultado]);

  const handleSelectDespesa = e => {
    if (e === 'capex') {
      setCapex(true);
      setOpex(false);
      setContaResultado(false);
    }
    if (e === 'opex') {
      setOpex(true);
      setCapex(false);
      setContaResultado(false);
    }
    if (e === 'resultado') {
      setContaResultado(true);
      setCapex(false);
      setOpex(false);
    }
    setTipoDespesa(e);
  };

  useEffect(() => {
    if (isValorComAcrescimoEscopo === false && isValorSemAcrescimoEscopo === false) {
      setValorAditivo(0);
    }
  }, [isValorComAcrescimoEscopo, isValorSemAcrescimoEscopo]);

  return (
    <>
      <ui.Row>
        <ui.FormItem name="checkContainer" required={checkEnable} validateSchema={validationSchema}>
          <div className="checkbox-group">
            <ui.Row>
              <ui.Col span={6}>
                <div>
                  <label>Prazo</label>
                  <Tooltip title="Extensão do prazo final de vigência do contrato.">
                    <Icon style={{ marginLeft: '4px' }} type="info-circle" />
                  </Tooltip>
                </div>
                <Switch
                  id="mrn-switch-isPrazo"
                  onChange={e => setIsPrazo(e)}
                  checked={isPrazo}
                  disabled={statusCodigo === 7 || statusCodigo === 9 || statusCodigo === 2 || statusCodigo === 6}
                />
              </ui.Col>
              <ui.Col span={6}>
                <div>
                  <label>Cláusula</label>
                  <Tooltip title="Alteração na narrativa de cláusula do contrato.">
                    <Icon style={{ marginLeft: '4px' }} type="info-circle" />
                  </Tooltip>
                </div>
                <Switch
                  onChange={e => setIsClausula(e)}
                  checked={isClausula}
                  id="mrn-switch-isClausula"
                  disabled={statusCodigo === 7 || statusCodigo === 9 || statusCodigo === 2 || statusCodigo === 6}
                />
              </ui.Col>
            </ui.Row>
            <ui.Row>
              <ui.Col span={6}>
                <div>
                  <label>Valor SEM Acréscimo de Escopo</label>
                  <Tooltip title="Acréscimo de valor a itens já existentes no contrato.">
                    <Icon style={{ marginLeft: '4px' }} type="info-circle" />
                  </Tooltip>
                </div>
                <Switch
                  onChange={e => {
                    setIsValorSemAcrescimoEscopo(e);
                    if (e === true) setIsValorComAcrescimoEscopo(false);
                  }}
                  checked={isValorSemAcrescimoEscopo}
                  id="mrn-switch-isValorSemAcrescimoEscopo"
                  disabled={statusCodigo === 7 || statusCodigo === 9 || statusCodigo === 2 || statusCodigo === 6}
                />
              </ui.Col>
              <ui.Col span={6}>
                <div>
                  <label>Remanejamento de Verbas Entre Linhas</label>
                  <Tooltip title="Redistribuição de saldos entre os itens existentes no contrato.">
                    <Icon style={{ marginLeft: '4px' }} type="info-circle" />
                  </Tooltip>
                </div>
                <Switch
                  checked={isRemanejamentoVerbasEntreLinhas}
                  id="mrn-switch-isRemanejamentoVerbasEntreLinhas"
                  onChange={e => setIsRemanejamentoVerbasEntreLinhas(e)}
                  disabled={statusCodigo === 7 || statusCodigo === 9 || statusCodigo === 2 || statusCodigo === 6}
                />
              </ui.Col>
            </ui.Row>
            <ui.Row>
              <ui.Col span={6}>
                <div>
                  <label>Valor COM Acréscimo de Escopo</label>
                  <Tooltip title="Inclusão de Itens Novos com acréscimo de valor.">
                    <Icon style={{ marginLeft: '4px' }} type="info-circle" />
                  </Tooltip>
                </div>
                <Switch
                  onChange={e => {
                    setIsValorComAcrescimoEscopo(e);
                    if (e === true) setIsValorSemAcrescimoEscopo(false);
                  }}
                  checked={isValorComAcrescimoEscopo}
                  id="mrn-switch-isValorComAcrescimoEscopo"
                  disabled={statusCodigo === 7 || statusCodigo === 9 || statusCodigo === 2 || statusCodigo === 6}
                />
              </ui.Col>
              <ui.Col span={6}>
                <div>
                  <label>Acréscimo de Escopo com Remanejamento de Verba</label>
                  <Tooltip title="Redistribuição de saldos entre os itens existentes no contrato e inclusão de Itens Novos">
                    <Icon style={{ marginLeft: '4px' }} type="info-circle" />
                  </Tooltip>
                </div>
                <Switch
                  checked={isAcrescimoEscopoRemanejamentoVerba}
                  id="mrn-switch-isAcrescimoEscopoRemanejamentoVerba"
                  onChange={e => setIsAcrescimoEscopoRemanejamentoVerba(e)}
                  disabled={statusCodigo === 7 || statusCodigo === 9 || statusCodigo === 2 || statusCodigo === 6}
                />
              </ui.Col>
            </ui.Row>
          </div>
        </ui.FormItem>
      </ui.Row>

      <ui.Row>
        <ui.FormDatePicker
          label="Prazo Atual do Contrato"
          name="prazoAtual"
          id="mrn-datepicker-prazoAtual"
          format="DD/MM/YYYY"
          span={4}
          disabled
          required
        />
        {isPrazo && (
          <ui.FormDatePicker
            label="Novo Prazo"
            name="novoPrazo"
            id="mrn-datepicker-novoPrazo"
            format="DD/MM/YYYY"
            span={4}
            disabled={statusCodigo === 7 || statusCodigo === 9 || statusCodigo === 2 || statusCodigo === 6}
            required
          />
        )}
      </ui.Row>

      <ui.Row>
        <CurrencyInput
          label="Valor Atual"
          name="valorAtual"
          id='mrn-currency-valorAtual'
          span={4} disabled required />
        {(isValorComAcrescimoEscopo || isValorSemAcrescimoEscopo) && (
          <CurrencyInput
            label="Valor Aditivo"
            name="valorAditivo"
            id='mrn-currency-valorAditivo'
            span={4}
            value={valorAditivo}
            onChange={e => setValorAditivo(e)}
            disabled={statusCodigo === 7 || statusCodigo === 9 || statusCodigo === 2 || statusCodigo === 6}
            required={valorAditivo === undefined || valorAditivo === 0}
          />
        )}
        <CurrencyInput
          value={demandaData.valorAtual + (valorAditivo ? valorAditivo : 0)}
          label="Novo Valor Final"
          name="novoValorFinal"
          id='mrn-currency-novoValorFinal'
          span={4}
          disabled
        />
      </ui.Row>

      <ui.Row>
        {isClausula && (
          <ui.FormTextArea
            label="Resumo Alterações de Cláusulas"
            name="resumoAlteracoesClausula"
            id="mrn-textarea-resumoAlteracoesClausula"
            disabled={statusCodigo === 7 || statusCodigo === 9 || statusCodigo === 2 || statusCodigo === 6}
            required
            maxLength={4000}
          />
        )}
      </ui.Row>
      <Visibility visible={demandaData && demandaData.tipo !== ETipoDemanda.AditivoFaturamentoDireto}>
      <ui.Row>
        <ui.FormSelect
          label="Tipo de Despesa"
          name="tipoDespesa"
          id="mrn-select-tipoDespesa"
          span={4}
          value={tipoDespesa}
          onSelect={e => handleSelectDespesa(e)}
          options={[
            { text: 'CAPEX', value: 'capex' },
            { text: 'OPEX', value: 'opex' },
            { text: 'Conta de Resultado', value: 'resultado' },
          ]}
          disabled={statusCodigo === 7 || statusCodigo === 9 || statusCodigo === 2 || statusCodigo === 6}
          required={demandaData &&
          demandaData.tipo !== ETipoDemanda.AditivoFaturamentoDireto &&
          (tipoDespesa === '' || tipoDespesa === undefined)}
        />
        </ui.Row>
      </Visibility>
    </>
  );

}

export default DefinicaoAdtivo;
